<div id="captureBillingPDF" style="width: 1100px; margin: auto;">
  <section class="user document">
    <div class="top">
      <div class="row red" *ngIf="docDetailInfo.PaymentType === null">
        <div class="col-md info">
          <h2>Billing Statement</h2>
          <h1>#{{this.docDetailInfo.DocNo}}</h1>
          <h5 class="comname">{{getPaymentInfo.PaymentName}}</h5>
          <ul>
            <li>{{getPaymentInfo.PaymentAddress}}</li>
          </ul>
        </div>
        <div class="col-md cominfo">
            <img src="../assets/images/cps_Logo_Red.png" class="img-fluid">
        </div>
      </div>
      <div class="row red" *ngIf="docDetailInfo.PaymentType !== null">
        <div class="col-md info">
          <h2>Billing Statement</h2>
          <h1>{{this.docDetailInfo.DocNo}}</h1>
        </div>
        <div class="col-md cominfo">
            <img src="../assets/images/cps_Logo_Red.png" class="img-fluid">
        </div>
      </div>
      <div class="info" *ngIf="docDetailInfo.PaymentType === null">
        <div class="row">
          <div class="col-md">
            <hr>
            <ul>
              <li><h5>{{getPaymentInfo.CompanyName}}</h5></li>
              <li>{{getPaymentInfo.Address}}</li>
              <li>{{getPaymentInfo.CompanyEmail}}</li>
            </ul>
          </div>
          <div class="col-md">
            <hr>
            <div class="padding-bottom-30">
              <p *ngIf="this.docDetailInfo.DocType === 1">Invoice Number</p>
              <p *ngIf="this.docDetailInfo.DocType === 0">P.O. Number</p>
              <ul>
                <li><h5>{{this.docDetailInfo.DocNo}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30" *ngIf="this.docDetailInfo.DocType === 1">
              <p>Invoice DATE</p>
              <ul>
                <li><h5>{{this.docDetailInfo.DocDate}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30">
              <p>Period</p>
              <ul>
                <li><h5>{{this.docDetailInfo.DocStartDay}} - {{this.docDetailInfo.DocEndDay}}</h5></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="info" *ngIf="docDetailInfo.PaymentType !== null">
        <div class="row">
          <div class="col-md">
            <hr>
            <div class="padding-bottom-30">
              <p>Company</p>
              <ul>
                <li><h5>{{getPaymentInfo.CompanyName}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30">
              <p>Company Email</p>
              <ul>
                <li><h5>{{getPaymentInfo.CompanyEmail}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30">
              <p>PPC PRO Account</p>
              <ul>
                <li><h5>{{getPaymentInfo.Company}}</h5></li>
              </ul>
            </div>
          </div>
          <div class="col-md">
            <hr>
            <div class="padding-bottom-30" *ngIf="docDetailInfo.PaymentType === PaymentTypeIndex.Monthly">
              <p>Statement Period</p>
              <ul>
                <li><h5>{{this.docDetailInfo.Period}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30" *ngIf="docDetailInfo.PaymentType === PaymentTypeIndex.Prepaid">
              <p>Statement Date</p>
              <ul>
                <li><h5>{{this.docDetailInfo.Period}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30">
              <p>P.O. Number</p>
              <ul>
                <li><h5>{{this.docDetailInfo.DocNo}}</h5></li>
              </ul>
            </div>
            <div class="padding-bottom-30">
              <p>Invoice Number</p>
              <ul>
                <li><h5>{{this.docDetailInfo.CorrNo}}</h5></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="padding-buttom-30 border-t-radius-none">
        <p-treeTable [value]="summaryList">
          <ng-template pTemplate="caption">
            <h5 *ngIf="docDetailInfo.PaymentType !== PaymentTypeIndex.Monthly">Summary</h5>
            <h5 *ngIf="docDetailInfo.PaymentType === PaymentTypeIndex.Monthly">Usage Summary</h5>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 360px;" *ngIf="docDetailInfo.PaymentType === null">COMPANY NAME</th>
              <th style="width: 360px;" *ngIf="docDetailInfo.PaymentType !== null">MODEL NAME</th>
              <th class="number important" *ngIf="docDetailInfo.PaymentType === null">QUANTITY</th>
              <th class="number important" *ngIf="docDetailInfo.PaymentType !== null">QUANTITY (NPM)</th>
              <th class="number">UNIT PRICE (USD)</th>
              <th class="number">Total amount (USD)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr>
              <td class="name" style="width: 360px;">
                <div class="inline-flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <div class="rowDataName" style="-webkit-box-orient: vertical;" *ngIf="docDetailInfo.PaymentType === null">{{rowData.name}}</div>
                  <div class="rowDataName" style="-webkit-box-orient: vertical;" *ngIf="docDetailInfo.PaymentType !== null">PPCPROMONTHLY</div>
                </div>
              </td>
              <td class="number"><span *ngIf="rowData.isDefaultQuantity" class="important">*</span> {{rowData.total_quantity}}</td>
              <td class="number">${{rowData.unitprice | number: '1.2-2'}}</td>
              <td class="number">${{rowData.total_amount | number: '1.2-2'}} </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td>PPCPROMONTHLY Total</td>
              <td></td>
              <td></td>
              <td class="number">${{summaryTotal.amount | number: '1.2-2'}}</td>
            </tr>
          </ng-template>
        </p-treeTable>
        <p class="note" *ngIf="this.getPaymentInfo.MinCharge > 0 && this.getPaymentInfo.ChargeType !== 0"><span>*</span> A minimum quantity of {{this.getPaymentInfo.MinCharge}} devices is required when using PPC PRO. </p>
      </div>
      <p-treeTable [value]="deviceUsageList" *ngIf="docDetailInfo.PaymentType !== PaymentTypeIndex.Prepaid">
        <ng-template pTemplate="caption">
          <h5>Detail</h5>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 360px;">COMPANY NAME</th>
            <th class="number important">Quantity (Last month)</th>
            <th class="number important">Growth Amount</th>
            <th class="number important">Quantity (This month)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr>
            <td class="name" style="width: 360px;">
              <div class="inline-flex">
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                <div class="rowDataName" style="-webkit-box-orient: vertical;">{{rowData.name}}</div>
              </div>
            </td>
            <td class="number">{{rowData.last_quantity}}</td>
            <td class="number">{{rowData.quantity - rowData.last_quantity}}</td>
            <td class="number">{{rowData.quantity}} </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
    <!-- <div class="bottom">
      <div class="row">
        <div class="col-md">
          <h5 class="comname">Cyber Power Systems, Inc.</h5>
          <div>11F., NO.26, JINZHUANG RD., NEIHU DIST, TAIPEI CITY 11469, TAIWAN (R.O.C.)</div>
          <div>TEL: +886 (02)8792-9510</div>
          <div>FAX: +886 (02)8792-9621</div>
        </div>
      </div>
    </div> -->
  </section>
</div>
